import { localStoragePersist } from "src/utilities/localStorage/persist"
import { create as createStore } from "zustand"

type State = {
  quantity: number
  active: boolean
}

const defaultState: State = {
  quantity: 1,
  active: false,
}

const store = createStore(localStoragePersist(() => defaultState, { name: "bulk-discount" }))

export function setBulkDiscountQuantity(quantity: number) {
  store.setState({ quantity })
}

export function useBulkDiscountQuantity() {
  return store((state) => state.quantity)
}
